import { createSelector } from 'reselect'
import { ReduxState } from '../reducers'
import type { ProjectDocumentFolder } from './ProjectCustomReducer'

/* Creating a selector for the calculs in the PCUSTOM state. */
export const selectCustomCalcul = (state: ReduxState) => {
  //@ts-ignore
  return state.calcul.PCUSTOM?.calculs || {}
}

/* Creating a selector for the folders in the PCUSTOM state. */
export const selectCustomFolders = createSelector(
  //@ts-ignore
  (state: ReduxState) => state.calcul.PCUSTOM?.folders || {},
  (value): ProjectDocumentFolder[] => Object.values(value) as ProjectDocumentFolder[]
)

export const selectCustomDocumentsFolders = () =>
  createSelector(
    //@ts-ignore
    (state: ReduxState) => state.calcul.PCUSTOM?.folders || {},
    (_: ReduxState, folderId: string) => folderId,
    (folders, folderId) => {
      return folders[folderId]
    }
  )

export const selectIsCustomSaved = createSelector(
  //@ts-ignore
  (state: ReduxState) => state.calcul.PCUSTOM?.id,
  value => isValidId(value)
)

//@ts-ignore
export const selectCustomId = (state: ReduxState) => state.calcul.PCUSTOM?.id || ''

//@ts-ignore
export const selectHasUnsavedChanges = (state: ReduxState) => state.calcul.PCUSTOM?.hasUnsavedChanges || false

//@ts-ignore
export const selectCustomProjectName = (state: ReduxState) => state.calcul.PCUSTOM?.projectName || ''

//@ts-ignore
export const selectCustomProjectDescription = (state: ReduxState) => state.calcul.PCUSTOM?.description || ''

//@ts-ignore
export const selectCustomProjectAddress = (state: ReduxState) => state.calcul.PCUSTOM?.address

//@ts-ignore
export const selectCustomProjectAddressComponents = (state: ReduxState) => state.calcul.PCUSTOM?.addressComponents

//@ts-ignore
export const selectCustomProjectAvancement = (state: ReduxState) => state.calcul.PCUSTOM?.avancement || '0'

export const selectCustomDocumentInFolders = () =>
  createSelector(
    //@ts-ignore
    (state: ReduxState) => state.calcul.PCUSTOM?.folders || {},
    (_: ReduxState, folderId: string) => folderId,
    (_: ReduxState, _folderId: string, docId: string) => docId,
    (folders, projectId, docId) => {
      return folders[projectId]?.documents?.[docId]
    }
  )

export const isValidId = (id: string | null | undefined) => {
  return id != null && id !== '0' && id !== ''
}
